import { mainApi } from "../api/root-api"
import { productData, requestProducts } from "../slices/productSlice"
import { setError, setSuccess } from "../slices/statusSlice"


// const productsUrl = 'info/products'
// const productsUrl = 'accounts/86742565-4b30-4bed-9bdf-c3b73f5a02f0/products'


export const getProducts = ( id, token ) => {
  let payload = {}
  return async ( dispatch ) => {
    dispatch(requestProducts())
    await mainApi.get(`accounts/${id}/products`, { headers: { authorization: token } }).then(resp => {
      
      payload = {
        message: 'Cuentas cargadas con éxito',
        status: resp.status
      } 
      dispatch(productData(resp.data))
    }).catch(err => {
      
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
    })
  }
}